import { render, staticRenderFns } from "./ConfiguracionDispositivoTkstar.vue?vue&type=template&id=16781371&scoped=true"
import script from "./ConfiguracionDispositivoTkstar.vue?vue&type=script&lang=js"
export * from "./ConfiguracionDispositivoTkstar.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracionDispositivoTkstar.vue?vue&type=style&index=0&id=16781371&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16781371",
  null
  
)

export default component.exports